import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, Bell, Zap, ChevronRight } from 'lucide-react'
import useAuthStore from '../../store/authStore'
import useOrgStore from '../../store/orgStore'
import { PlanBadge } from '../ui/Badge'
import { getEffectivePlan } from '../../lib/subscription'
import { LanguageSwitch } from '../../i18n/LanguageSwitch'
import { useLocale } from '../../i18n/LocaleProvider'

export function TopBar({ onMenuClick, title, subtitle }) {
  const { user } = useAuthStore()
  const { org, usage } = useOrgStore()
  const navigate = useNavigate()
  const [showUpgradeBanner, setShowUpgradeBanner] = useState(true)
  const { t } = useLocale()

  const plan = getEffectivePlan({ user, org, usage })
  const showBanner =
    showUpgradeBanner &&
    usage &&
    (usage.jobUsagePercent >= 80 || usage.cvUsagePercent >= 80) &&
    plan !== 'enterprise' &&
    plan !== 'admin'

  return (
    <div className="sticky top-0 z-30 bg-white border-b border-gray-100">
      {/* Upgrade banner */}
      {showBanner && (
        <div className="bg-gradient-to-r from-brand-600 to-brand-500 px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2 text-white text-sm">
            <Zap className="w-4 h-4 shrink-0" />
            <span>
              {usage.jobUsagePercent >= 80
                ? t('authenticated.app.topBar.jobUsage', { percent: usage.jobUsagePercent })
                : t('authenticated.app.topBar.cvUsage', { percent: usage.cvUsagePercent })}
              {' '}{t('authenticated.app.topBar.upgradeMore')}
            </span>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={() => navigate('/dashboard/settings?tab=billing')}
              className="text-white text-sm font-semibold flex items-center gap-1 hover:underline"
            >
              {t('authenticated.app.topBar.upgradeNow')}
              <ChevronRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => setShowUpgradeBanner(false)}
              className="text-white opacity-70 hover:opacity-100 text-lg leading-none ml-2"
              aria-label={t('authenticated.app.topBar.closeBanner')}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* Main top bar */}
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3">
          {/* Mobile menu button */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu className="w-5 h-5" />
          </button>

          {/* Page title */}
          {title && (
            <div>
              <h1 className="text-lg font-bold text-gray-900 leading-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="text-xs text-gray-500">{subtitle}</p>
              )}
            </div>
          )}
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2">
          <LanguageSwitch />
          <PlanBadge plan={plan} />

          <div className="w-8 h-8 rounded-full bg-brand-100 flex items-center justify-center">
            <span className="text-xs font-bold text-brand-700">
              {user?.name?.charAt(0)?.toUpperCase() ||
                user?.email?.charAt(0)?.toUpperCase() ||
                '?'}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
